/**
 * vion-icon v1.0.1
 * (c) 2023 yangling
 * @license MIT
 */

import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, createElementVNode } from 'vue';

var Home = defineComponent({
  name: "Home",
  props: {
    color: String,
    size: String
  },
  emits: ["click"],
  setup: function setup(props, ctx) {
    var iconStyle = computed(function () {
      return {
        display: "inline-block",
        fontSize: props.size,
        color: props.color,
        width: "1em",
        height: "1em",
        lineHeight: "1em"
      };
    });
    var click = function click(e) {
      return ctx.emit("click", e);
    };
    return {
      iconStyle: iconStyle,
      click: click
    };
  }
});
Home.install = function (app) {
  app.component(Home.name, Home);
};

var _hoisted_1 = /* @__PURE__ */createElementVNode("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 48 48",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [/* @__PURE__ */createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M25.5555 8.26791L24.2537 7.14508L22.9481 8.26341L20.7826 10.1183L3.86905 24.5845L6.46899 27.6243L9.34513 25.1643V39.0687C9.34513 40.836 10.7778 42.2687 12.5451 42.2687H35.9533C37.7206 42.2687 39.1533 40.836 39.1533 39.0687V25.1788L42.0124 27.6243L44.6123 24.5845L27.9314 10.3173L25.5555 8.26791ZM23.5636 13.0032L23.3817 13.1588L13.3451 21.7557V38.2687H22V30.7824H26V38.2687H35.1533V21.8289L25.3252 13.3517L24.9178 13.0032L24.9192 13.0015L24.2446 12.4197L23.5635 13.0031L23.5636 13.0032Z",
  fill: "currentColor"
})], -1);
var _hoisted_2 = [_hoisted_1];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("i", {
    class: "v-icon",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.click && _ctx.click.apply(_ctx, arguments);
    }),
    style: normalizeStyle(_ctx.iconStyle)
  }, _hoisted_2, 4);
}

Home.render = render;

export { Home as default };
